@import 'src/global/theme-variables';

.rv-percentage {
  line-height: 1.5;
  display: flex;
  font-size: 14px;
  font-weight: 500;

  .rv-positive {
    color: $positive;
  }

  .rv-negative {
    color: $negative;
  }
}
